export default __webpack_public_path__ + "static/media/Create-documentation.dac9004b.md";